var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScheduleImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 177.635,
    height: 188.072,
    viewBox: "0 0 177.635 188.072",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2179",
    "data-name": "Grupo 2179",
    transform: "translate(-87 -121.927)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1710",
    "data-name": "Grupo 1710",
    transform: "translate(-76.45 -140.05)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1698",
    "data-name": "Grupo 1698",
    transform: "translate(214.635 282.05)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1692",
    "data-name": "Grupo 1692",
    transform: "translate(7.495)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_393",
    "data-name": "Caminho 393",
    d: "M293.211,323.686h-1.519a40.117,40.117,0,1,0-80.234,0h-1.519a41.636,41.636,0,1,1,83.272,0Z",
    transform: "translate(-209.939 -282.05)",
    fill: "#d3ff9a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1693",
    "data-name": "Grupo 1693",
    transform: "translate(0 40.876)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_394",
    "data-name": "Caminho 394",
    d: "M298.1,319.274h-87.95a5.157,5.157,0,1,1,0-10.314H298.1a5.171,5.171,0,0,1,5.165,5.165,5.168,5.168,0,0,1-5.165,5.149Zm-87.95-8.8a3.628,3.628,0,0,0-2.578,1.068,3.646,3.646,0,0,0,2.578,6.208H298.1a3.57,3.57,0,0,0,2.572-1.063,3.608,3.608,0,0,0,1.074-2.567,3.65,3.65,0,0,0-3.646-3.646Z",
    transform: "translate(-205.005 -308.96)",
    fill: "#d3ff9a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1694",
    "data-name": "Grupo 1694",
    transform: "translate(79.843 50.431)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_395",
    "data-name": "Caminho 395",
    d: "M259.084,338.46l-1.516-.091c.03-.488.044-.972.044-1.458V315.25h1.519V336.9C259.131,337.427,259.116,337.944,259.084,338.46Z",
    transform: "translate(-257.568 -315.25)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1695",
    "data-name": "Grupo 1695",
    transform: "translate(16.864 50.431)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_396",
    "data-name": "Caminho 396",
    d: "M216.154,338.46c-.03-.516-.047-1.033-.047-1.549V315.25h1.519V336.9c0,.5.015.986.044,1.473Z",
    transform: "translate(-216.107 -315.25)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1696",
    "data-name": "Grupo 1696",
    transform: "translate(7.65 49.894)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_877",
    "data-name": "Ret\\xE2ngulo 877",
    width: 1.519,
    height: 13.34,
    transform: "translate(0 1.074) rotate(-45)",
    fill: "#d3ff9a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1697",
    "data-name": "Grupo 1697",
    transform: "translate(80.106 49.894)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_878",
    "data-name": "Ret\\xE2ngulo 878",
    width: 13.663,
    height: 1.519,
    transform: "translate(0 9.661) rotate(-45)",
    fill: "#d3ff9a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1705",
    "data-name": "Grupo 1705",
    transform: "translate(186.45 335.32)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1700",
    "data-name": "Grupo 1700",
    transform: "translate(0 18.805)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1699",
    "data-name": "Grupo 1699"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_397",
    "data-name": "Caminho 397",
    d: "M187.21,411.221a.759.759,0,0,1-.76-.759V347.5a18.02,18.02,0,0,1,18-18H319.393a.76.76,0,0,1,0,1.519H204.45A16.5,16.5,0,0,0,187.969,347.5v62.963A.76.76,0,0,1,187.21,411.221Z",
    transform: "translate(-186.45 -329.499)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1702",
    "data-name": "Grupo 1702",
    transform: "translate(17.241 18.805)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1701",
    "data-name": "Grupo 1701"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_398",
    "data-name": "Caminho 398",
    d: "M202.235,331.018H198.56a.76.76,0,0,1,0-1.519h3.676a.76.76,0,0,1,0,1.519Z",
    transform: "translate(-197.8 -329.499)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1704",
    "data-name": "Grupo 1704"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1703",
    "data-name": "Grupo 1703"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_399",
    "data-name": "Caminho 399",
    d: "M187.21,431.849a.758.758,0,0,1-.76-.759v-14.2a.759.759,0,1,1,1.519,0v7.521c2.631-5.18,8.529-8.28,16.466-8.28H329.859a9.71,9.71,0,0,0,9.706-9.691,9.52,9.52,0,0,0-1.589-5.3,9.672,9.672,0,0,0-8.118-4.4H319.393a.758.758,0,0,1-.76-.759V317.879a.759.759,0,0,1,.76-.759H323.1A18.006,18.006,0,0,1,341.084,335.1v71.332a11.23,11.23,0,0,1-11,11.207c-.018,0-.038,0-.058,0H204.435c-7.961,0-16.466,3.532-16.466,13.443A.759.759,0,0,1,187.21,431.849Zm132.943-36.638h9.706a11.18,11.18,0,0,1,9.384,5.084c.112.167.22.339.322.512V335.1A16.484,16.484,0,0,0,323.1,318.638h-2.947Z",
    transform: "translate(-186.45 -317.119)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1709",
    "data-name": "Grupo 1709",
    transform: "translate(230.914 377.164)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1706",
    "data-name": "Grupo 1706"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_400",
    "data-name": "Caminho 400",
    d: "M280.668,346.185H216.481a.759.759,0,1,1,0-1.519h64.187a.759.759,0,1,1,0,1.519Z",
    transform: "translate(-215.722 -344.666)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1707",
    "data-name": "Grupo 1707",
    transform: "translate(0 17.061)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_401",
    "data-name": "Caminho 401",
    d: "M250.288,357.417H216.481a.759.759,0,1,1,0-1.519h33.807a.759.759,0,1,1,0,1.519Z",
    transform: "translate(-215.722 -355.898)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1708",
    "data-name": "Grupo 1708",
    transform: "translate(0 34.126)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_402",
    "data-name": "Caminho 402",
    d: "M280.668,368.651H216.481a.76.76,0,0,1,0-1.519h64.187a.76.76,0,1,1,0,1.519Z",
    transform: "translate(-215.722 -367.132)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1711",
    "data-name": "Grupo 1711",
    transform: "translate(-952.055 -283.789)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_403",
    "data-name": "Caminho 403",
    d: "M1039.109,466.017a.543.543,0,0,1,.245-.723l23.916-11.921a.542.542,0,0,1,.753.667l-8.947,25.114a.542.542,0,0,1-1,.056l0,0-4.539-9.546-10.112-3.367A.543.543,0,0,1,1039.109,466.017Zm23.441-11.073-21.538,10.736,9.087,3.026a.628.628,0,0,1,.319.282l4.076,8.571Z",
    transform: "translate(0)",
    fill: "#d3ff9a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1714",
    "data-name": "Grupo 1714",
    transform: "translate(-815.35 54.795)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1712",
    "data-name": "Grupo 1712",
    transform: "translate(1054.164 67.132)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_404",
    "data-name": "Caminho 404",
    d: "M1067.073,106.4a1.729,1.729,0,0,1-1.521-.9l-10.176-19.691a13.333,13.333,0,0,1,.735-12.489,12.6,12.6,0,0,1,10.247-6.168h0c.472-.023.956-.023,1.428,0a12.6,12.6,0,0,1,10.248,6.168,13.314,13.314,0,0,1,.751,12.454L1068.6,105.486a1.733,1.733,0,0,1-1.526.917Zm-.648-37.9a11.261,11.261,0,0,0-9.155,5.518,11.967,11.967,0,0,0-.675,11.193l10.156,19.648a.359.359,0,0,0,.322.184.366.366,0,0,0,.328-.2l10.166-19.672a11.951,11.951,0,0,0-.691-11.157,11.263,11.263,0,0,0-9.157-5.518c-.426-.021-.866-.021-1.294,0Z",
    transform: "translate(-1054.164 -67.132)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1713",
    "data-name": "Grupo 1713",
    transform: "translate(1059.505 72.541)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_405",
    "data-name": "Caminho 405",
    d: "M1075.059,95.764a7.567,7.567,0,1,0-7.567-7.567A7.576,7.576,0,0,0,1075.059,95.764Zm0-13.667a6.1,6.1,0,1,1-6.1,6.1A6.106,6.106,0,0,1,1075.059,82.1Z",
    transform: "translate(-1067.492 -80.629)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScheduleImage);
export default __webpack_public_path__ + "static/media/scheduleImage.00e900b94b1c0b67b7ef10528fa3d723.svg";
export { ForwardRef as ReactComponent };